import {RGroup} from '@datagrok-libraries/bio/src/types/monomer-library';

export const STANDRARD_R_GROUPS: RGroup[] = [
  {
    alternateId: 'R1-H',
    capGroupName: 'H',
    capGroupSmiles: '[*:1][H]',
    label: 'R1'
  },
  {
    alternateId: 'R2-OH',
    capGroupName: 'OH',
    capGroupSmiles: 'O[*:2]',
    label: 'R2'
  },
  {
    alternateId: 'R3-H',
    capGroupName: 'H',
    capGroupSmiles: '[*:3][H]',
    label: 'R3'
  },
  {
    alternateId: 'R4-H',
    capGroupName: 'H',
    capGroupSmiles: '[*:4][H]',
    label: 'R4'
  },
  {
    alternateId: 'R5-H',
    capGroupName: 'H',
    capGroupSmiles: '[*:5][H]',
    label: 'R5'
  },
  {
    alternateId: 'R6-H',
    capGroupName: 'H',
    capGroupSmiles: '[*:6][H]',
    label: 'R6'
  },
];
